// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"bfcd5c0d","667":"e8ab8060","733":"8980182e","812":"7e071406","977":"2233c532"}[chunkId] + ".chunk.js";
};